import React, { isValidElement } from 'react'

import { Text } from '@interco/inter-ui/components/Text'
import { Spacing } from '@interco/inter-ui/components/Spacing'
import { Button } from '@interco/inter-ui/components/Button'
import { requestAnalytics } from '@/services/bridge'

import { IconList } from '../icon-list'
import * as S from './styles'

type OnActionClickProps = Pick<OverdraftDetailsComponentActionOption, 'actionUrl' | 'actionVariant'>

interface MessageStatusPros extends Partial<OverdraftDetailsComponent> {
  onActionClick?: (props: OnActionClickProps) => void
}

export const MessageStatus = (component: MessageStatusPros) => {
  const { type, title, description, icon, actionOptions, onActionClick } = component

  if (type === 'SUCCESS') {
    requestAnalytics('CHEQUEESPECIAL_SUCESSO', {
      screen: 'Home do contrato',
      ref_figma: '4',
      ref_type: 'sucesso',
      content_action: 'Dado carregado',
      content_id: title ?? '',
      product: 'ChequeEspecial',
    })
  }

  return (
    <S.Container>
      <S.ContentMessage>
        <S.ContainerIcon type={type}>
          {icon && <IconList name={icon} color="var(--neutral-theme)" iconSize={32} />}
        </S.ContainerIcon>
        {title && (
          <Text color="typography" colorWeight={500} variant="headline-h1" semiBold>
            {title}
          </Text>
        )}
        {description && (
          <>
            <Spacing mb="sm" />
            {isValidElement(description) ? (
              description
            ) : (
              <Text colorWeight={400} variant="body-3">
                {description}
              </Text>
            )}
          </>
        )}
      </S.ContentMessage>

      {actionOptions && actionOptions.length > 0 && (
        <S.ContentActions>
          {actionOptions.map((item) => (
            <>
              <Button
                variant={item.actionVariant ?? 'primary'}
                onClick={() => {
                  if (!onActionClick) return

                  onActionClick({
                    actionUrl: item.actionUrl,
                    actionVariant: item.actionVariant,
                  })

                  requestAnalytics('CHEQUEESPECIAL_SUCESSO', {
                    screen: 'Home do contrato',
                    ref_figma: '4',
                    ref_type: 'sucesso',
                    content_action: 'Toque',
                    content_id: item.title ?? 'Button',
                    product: 'ChequeEspecial',
                  })
                }}
              >
                {item.title}
              </Button>
              <Spacing mb="xs" />
            </>
          ))}
          <Spacing mb="xxs" />
        </S.ContentActions>
      )}
    </S.Container>
  )
}
